const MessageType = {};
MessageType.T = "T";//T:文本
MessageType.A = "A";//T:音频
MessageType.I = "I";//I:图片
MessageType.V = "V";//V:视频
MessageType.VOICE = "VOICE";// VOICE:语音
MessageType.F = "F";// F:文件
MessageType.S1 = "S1";//S1:系统消息(发送给顾客)
MessageType.S3 = "S3";//S3:系统消息(发送给顾客)未保存库
MessageType.R = "R";//R:机器人回复消息


MessageType.Z = "Z";//R:机器人回复消息
MessageType.L = "L";//L:机器人待回复动画

export default MessageType;